import React from 'react';
import { Typography, Tooltip } from '@mui/material';

interface OpportunityTitleProps {
  title: string;
  maxLines?: number;
}

export const OpportunityTitle: React.FC<OpportunityTitleProps> = ({ title, maxLines = 1 }) => {
  return (
    <Tooltip title={title} placement="top">
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        sx={{
          display: '-webkit-box',
          WebkitLineClamp: maxLines,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          lineHeight: 1.3,
          mb: 1,
          fontSize: '0.95rem',
          color: 'text.primary',
        }}
      >
        {title}
      </Typography>
    </Tooltip>
  );
};
